import { render } from "./FileBrowserTable.vue?vue&type=template&id=334221b9"
import script from "./FileBrowserTable.vue?vue&type=script&lang=js"
export * from "./FileBrowserTable.vue?vue&type=script&lang=js"

import "./FileBrowserTable.vue?vue&type=style&index=0&id=334221b9&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__